import React from 'react';
import {
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
} from '@mui/material';

export interface ProductoLoteControlFields {
  controlLoteSerie?: string | null;
  requiereVencimiento?: boolean | null;
  diasAlertaVencimiento?: number | null;
  idLoteNumeracion?: number | null;
  invetariado?: number | null;
  tipoArticulo?: string | null;
  cantidad?: number | null;
}

interface ProductoFormLoteControlsProps {
  formData: ProductoLoteControlFields;
  onChange: (patch: Partial<ProductoLoteControlFields>) => void;
  inventariadoEditable: boolean;
}

const ProductoFormLoteControls: React.FC<ProductoFormLoteControlsProps> = ({
  formData,
  onChange,
  inventariadoEditable,
}) => {
  const control = (formData.controlLoteSerie || 'N').toUpperCase();
  const esSer = String(formData.tipoArticulo ?? '').trim().toUpperCase() === 'SER';
  const inventariado = !!formData.invetariado;
  const disabled = !inventariado || esSer || !inventariadoEditable;
  const stockCero = (formData.cantidad ?? 0) === 0;

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1 }}>
          Control de lote / serie
        </Typography>
        {!stockCero && control === 'N' && (
          <Typography variant="caption" color="warning.main">
            Para activar el control, el stock del producto debe estar en cero.
          </Typography>
        )}
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControl fullWidth size="small" disabled={disabled || (!stockCero && control === 'N')}>
          <InputLabel>Control</InputLabel>
          <Select
            label="Control"
            value={control}
            onChange={(e) => onChange({ controlLoteSerie: e.target.value })}
          >
            <MenuItem value="N">Sin control</MenuItem>
            <MenuItem value="L">Por lote</MenuItem>
            <MenuItem value="S">Por serie</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          disabled={disabled || control === 'N'}
          control={
            <Switch
              checked={!!formData.requiereVencimiento}
              onChange={(e) => onChange({ requiereVencimiento: e.target.checked })}
              color="primary"
            />
          }
          label="Requiere vencimiento"
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          fullWidth
          size="small"
          type="number"
          label="Días alerta vencimiento"
          value={formData.diasAlertaVencimiento ?? 30}
          onChange={(e) => onChange({ diasAlertaVencimiento: Number(e.target.value) || 0 })}
          disabled={disabled || control === 'N'}
          inputProps={{ min: 0 }}
        />
      </Grid>
    </>
  );
};

export default ProductoFormLoteControls;
